import { configureStore } from '@reduxjs/toolkit';
import transactionsReducer from './slices/transactionsSlice';
import leaderboardReducer from './slices/leaderboardSlice';
import rewardReducer from './slices/rewardSlice';
import authReducer from './slices/authSlice';
import userManagementReducer from './slices/userManagementSlice';
import betHouseReducer from './slices/betHouseSlice';
import p2pShowcaseReducer from './slices/p2pShowcaseSlice';
import predictionShowcaseReducer from './slices/predictionShowcaseSlice';
import leaderboardShowcaseReducer from './slices/leaderboardShowcaseSlice';
import jobsReducer from './slices/jobsSlice';
import adminOverviewReducer from '../admin/redux/adminOverviewSlice';
import appAuthReducer from '../app/redux/appAuthSlice';
import betChatReducer from '../app/redux/betChatSlice';
import generalChatReducer from '../app/redux/bondchat/generalChatSlice';
import activityReducer from '../app/redux/activitySlice';
import predictionsReducer from '../app/redux/predictionsSlice';
import dashboardReducer from '../app/redux/dashboardSlice';
import operatorConsoleReducer from '../app/redux/operatorConsoleSlice';
import oddsCustomizeReducer from '../app/redux/oddsCustomizeSlice';
import joinedBetsReducer from '../app/redux/joinedBetsSlice';
import requestsReducer from '../app/redux/requestsSlice';
import referralReducer from '../app/redux/referralSlice';
import sessionCoolingReducer from '../app/redux/sessionCoolingSlice';
import profileReducer from '../app/redux/profileSlice';
import accountReducer from '../app/redux/accountSlice';
import bondPredictReducer from '../app/redux/bondPredictSlice';
import bettingDeskReducer from '../app/redux/bettingDeskSlice';
import bondWheelReducer from '../app/redux/bondWheelSlice';
import casinoReducer from '../app/redux/casinoSlice';
import bondDrawReducer from '../app/redux/bondDrawSlice';
import coinPoolReducer from '../app/redux/coinPoolSlice';
import coinFlipReducer from '../app/redux/coinFlipSlice';
import bondDiceReducer from '../app/redux/bondDiceSlice';
import bondNumbersReducer from '../app/redux/bondNumbersSlice';
import workspaceNavReducer from '../app/redux/workspaceNavSlice';
import networkReducer from './slices/networkSlice';

export const store = configureStore({
  reducer: {
    network: networkReducer,
    transactions: transactionsReducer,
    leaderboard: leaderboardReducer,
    reward: rewardReducer,
    auth: authReducer,
    appAuth: appAuthReducer,
    betChat: betChatReducer,
    generalChat: generalChatReducer,
    activities: activityReducer,
    predictions: predictionsReducer,
    dashboard: dashboardReducer,
    operatorConsole: operatorConsoleReducer,
    oddsCustomize: oddsCustomizeReducer,
    joinedBets: joinedBetsReducer,
    requests: requestsReducer,
    referrals: referralReducer,
    sessionCooling: sessionCoolingReducer,
    profile: profileReducer,
    account: accountReducer,
    bondPredict: bondPredictReducer,
    bettingDesk: bettingDeskReducer,
    bondWheel: bondWheelReducer,
    casino: casinoReducer,
    bondDraw: bondDrawReducer,
    coinPool: coinPoolReducer,
    coinFlip: coinFlipReducer,
    bondDice: bondDiceReducer,
    bondNumbers: bondNumbersReducer,
    workspaceNav: workspaceNavReducer,
    userManagement: userManagementReducer,
    betHouse: betHouseReducer,
    p2pShowcase: p2pShowcaseReducer,
    predictionShowcase: predictionShowcaseReducer,
    leaderboardShowcase: leaderboardShowcaseReducer,
    jobs: jobsReducer,
    adminOverview: adminOverviewReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 